const utility = {
  methods: {
    // 获取UUID
    uuid: function () {
      let s = []
      let hexDigits = '0123456789abcdef'
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
      }
      s[14] = '4' // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1) // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = '-'

      return s.join('')
    },
    // 获取时间戳
    timestamp: function () {
      return '' + (new Date()).valueOf()
    },
    // 获取本机日期
    localdate: function () {
      return this.formatDateTime(new Date(), 'yyyy-MM-dd')
    },
    // 获取本机日期时间
    localdatetime: function () {
      return this.formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
    },
    // 获取本机时间
    localtime: function () {
      return this.formatDateTime(new Date(), 'HH:mm:ss')
    },
    // 格式化日期输出
    formatDateTime: function (date, fmt) {
      var o = {
        'M+': date.getMonth() + 1, // 月份
        'd+': date.getDate(), // 日
        'H+': date.getHours(), // 小时
        'h+': date.getHours(), // 小时
        'm+': date.getMinutes(), // 分
        's+': date.getSeconds(), // 秒
        'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
        'S': date.getMilliseconds() // 毫秒
      }
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
        }
      }
      return fmt
    },
    // 对象深拷贝
    deep: function (obj) {
      // 判断拷贝的要进行深拷贝的是数组还是对象，是数组的话进行数组拷贝，对象的话进行对象拷贝
      let objClone = Array.isArray(obj) ? [] : {}
      // 进行深拷贝的不能为空，并且是对象或者是
      if (obj && typeof obj === 'object') {
        for (let key in obj) {
          if (obj.hasOwnProperty(key)) {
            if (obj[key] && typeof obj[key] === 'object') {
              objClone[key] = this.deep(obj[key])
            } else {
              objClone[key] = obj[key]
            }
          }
        }
      }
      return objClone
    },
    err_userinfo: function (err) {
      this.$alert(err, {
        confirmButtonText: '确定',
        callback: action => {
          localStorage.setItem('Flag', false)
          this.$router.push('/login')
          location.reload()
        }
      });
    },
    // 获取用户概要信息
    get_usrinfo: function () {
      let flag = localStorage.getItem('Flag')

      if (flag === 'true') {
        let token = localStorage.getItem('token')
        if (token === undefined || token === null) {
          this.err_userinfo('会话已失效，请重新登录')
        } else {
          let _entid = localStorage.getItem('entid')
          let _entname = localStorage.getItem('entname')
          //let password = localStorage.getItem('password')
          // let _staffid = localStorage.getItem('staffid')
          // let _staffname = localStorage.getItem('staffname')
          return {
            entid: _entid,
            entname: _entname,
            //password:password,
            // staffid: _staffid,
            // staffname: _staffname,
            token: token
          }
        }
      } else {
        return {
          entid: '',
          entname: '',
          // staffid: '',
          // staffname: '---',
          token: '',
         // password:''
        }
      }
    },
    // 错误处理提示
    err_process: function (code, err) {
      switch (code) {
        case 0: {
          localStorage.removeItem('token')
          this.err_userinfo(err)
          break
        }
        default: {
          this.msgBox(err)
          break
        }
      }
    },
    msgBox: function (msg) {
      try {
        this.$alert(msg, {
          confirmButtonText: '确定',
          callback: action => {
          }
        })
      }catch (ex) {
        console.error(ex)
        alert(msg)
      }
    }
  },
  data: function () {
    return {
      usrinfo: this.get_usrinfo()
    }
  }
}

export default utility
